import LegalPage, { LegalSection, LegalList } from "@/components/marketing/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" updated="July 2026" testid="terms-page">
      <LegalSection title="1. The service">
        <p>
          Guinep Seed gives small service businesses one simple page where clients can see their
          services, availability, and policies, and reach out without the back-and-forth. These
          terms apply when you create an account or use Guinep Seed.
        </p>
      </LegalSection>

      <LegalSection title="2. Your account">
        <p>
          You are responsible for keeping your account details accurate and your sign-in information
          secure. You must be able to legally agree to these terms on behalf of your business.
        </p>
      </LegalSection>

      <LegalSection title="3. Your content and public page">
        <p>
          You own the content you add to your Guinep Seed page, including your services, prices,
          policies, and Now updates. You are responsible for making sure that content is accurate,
          lawful, and does not mislead clients.
        </p>
        <p>
          Content you publish on your page may be visible publicly, so only share what you are
          comfortable making public.
        </p>
      </LegalSection>

      <LegalSection title="4. Enquiries and WhatsApp">
        <p>
          Guinep Seed helps clients send you structured enquiries and continue the conversation in
          WhatsApp. Guinep Seed is not a party to the conversations or agreements between you and
          your clients, and arrangements made over WhatsApp are subject to WhatsApp's own terms.
        </p>
      </LegalSection>

      <LegalSection title="5. Subscription and payment">
        <LegalList
          items={[
            "The Founding Plan is $9 per month",
            "New accounts start with a 7-day free trial",
            "You can cancel your subscription at any time",
            "Guinep Seed does not take commission or transaction fees on your client work",
          ]}
        />
      </LegalSection>

      <LegalSection title="6. Acceptable use">
        <p>You agree not to use Guinep Seed to:</p>
        <LegalList
          items={[
            "Publish unlawful, misleading, or harmful content",
            "Impersonate another business or person",
            "Interfere with or attempt to disrupt the service",
            "Send spam or unwanted messages through enquiry features",
          ]}
        />
      </LegalSection>

      <LegalSection title="7. Availability of the service">
        <p>
          We work to keep Guinep Seed available and reliable, but we cannot guarantee uninterrupted
          access. We may update, pause, or change parts of the service as it develops.
        </p>
      </LegalSection>

      <LegalSection title="8. Changes to the service or these terms">
        <p>
          If we change these terms, we will post the new version on this page and update the date
          above. Continuing to use Guinep Seed after a change means you accept the updated terms.
        </p>
      </LegalSection>

      <LegalSection title="9. Limitation of liability">
        <p>
          Guinep Seed provides a page and enquiry tool for your business. We are not responsible for
          the outcomes of client conversations, bookings, payments, or arrangements made between you
          and your clients.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact">
        <p>
          Questions about these terms? Contact us at{" "}
          <a
            href="mailto:hello@guinepseed.com"
            data-testid="terms-contact-email-link"
            className="font-medium text-guinep-mid underline underline-offset-4 transition-colors hover:text-guinep-deep"
          >
            hello@guinepseed.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
